const MAINTENANCE_BYPASS_STORAGE_KEY = 'oraMaintenanceBypass';
const MAINTENANCE_BYPASS_QUERY_PARAM = 'maintenanceBypass';

const normalizeOptionalString = (value: unknown): string | null => {
  if (typeof value !== 'string') {
    return null;
  }

  const normalized = value.trim();
  return normalized.length > 0 ? normalized : null;
};

const isBrowser = (): boolean => {
  return typeof window !== 'undefined';
};

export const isMaintenanceModeEnabled = (): boolean => {
  return import.meta.env.VITE_MAINTENANCE_MODE === 'true';
};

export const getMaintenanceBypassKey = (): string | null => {
  return normalizeOptionalString(import.meta.env.VITE_MAINTENANCE_BYPASS_KEY);
};

export const hasMaintenanceBypass = (): boolean => {
  if (!isBrowser()) {
    return false;
  }

  return localStorage.getItem(MAINTENANCE_BYPASS_STORAGE_KEY) === '1';
};

const enableMaintenanceBypass = (): void => {
  if (!isBrowser()) {
    return;
  }

  localStorage.setItem(MAINTENANCE_BYPASS_STORAGE_KEY, '1');
};

const disableMaintenanceBypass = (): void => {
  if (!isBrowser()) {
    return;
  }

  localStorage.removeItem(MAINTENANCE_BYPASS_STORAGE_KEY);
};

const removeBypassQueryParamFromUrl = (): void => {
  if (!isBrowser()) {
    return;
  }

  const url = new URL(window.location.href);
  if (!url.searchParams.has(MAINTENANCE_BYPASS_QUERY_PARAM)) {
    return;
  }

  url.searchParams.delete(MAINTENANCE_BYPASS_QUERY_PARAM);
  const nextUrl = `${url.pathname}${url.search}${url.hash}`;
  window.history.replaceState(window.history.state, '', nextUrl);
};

export const consumeMaintenanceBypassFromUrl = (): void => {
  if (!isBrowser()) {
    return;
  }

  const url = new URL(window.location.href);

  const bypassValue = normalizeOptionalString(
    url.searchParams.get(MAINTENANCE_BYPASS_QUERY_PARAM)
  );

  if (!bypassValue) {
    return;
  }

  if (bypassValue === 'off') {
    disableMaintenanceBypass();
    removeBypassQueryParamFromUrl();
    return;
  }

  const bypassKey = getMaintenanceBypassKey();
  if (bypassKey && bypassValue === bypassKey) {
    enableMaintenanceBypass();
  }

  removeBypassQueryParamFromUrl();
};

export const shouldHardBlockForMaintenance = (): boolean => {
  return isMaintenanceModeEnabled() && !hasMaintenanceBypass();
};

export const resolveMaintenanceHardBlock = (): boolean => {
  consumeMaintenanceBypassFromUrl();
  return shouldHardBlockForMaintenance();
};
